<ng-dialog-header title="Empty Car Request"></ng-dialog-header>
<mat-dialog-content>
  <ng-container *ngTemplateOutlet="emptyCarRequest"></ng-container>
</mat-dialog-content>
<ng-dialog-footer>
  <div class="d-flex justify-content-end overflow-hidden w-100" dialog-actions>
    <button mat-stroked-button color="warn" class="mr-2" [mat-dialog-close]="false">Close</button>
    <button mat-flat-button color="accent" [mat-dialog-close]="isFormValid" [disabled]="!isFormValid" (click)="emitEcrData()">
      Accept
    </button>
  </div>
</ng-dialog-footer>

<ng-template #emptyCarRequest>
  <h4>Empty car request is not used to request the placement of empty railcars. It is used for shippers to request empty equipment to load.</h4>
  <mat-divider class="mb-3 mt-2"></mat-divider>
  <form [formGroup]="ecrForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Select all of the different empty types of equipment required</mat-label>
      <mat-select formControlName="equipmentTypes" multiple>
        <mat-select-trigger>
          <mat-chip-list>
            <mat-chip *ngFor="let name of chipsCtrl.value" [removable]="true" (removed)="removeEquipment(name)">
              {{ name }}
              <mat-icon matChipRemove fontSet="fas" fontIcon="fa-times"></mat-icon>
            </mat-chip>
          </mat-chip-list>
        </mat-select-trigger>
        <mat-option class="mat-accent" *ngFor="let equipment of equipmentTypes" [value]="equipment.name">{{equipment.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <ns-autocomplete [data]="railRoadCompanyData" [filter]=false [formCtrl]="ecrForm.controls.railRoadCompany"
                     label="What railroad company will serve your rail loading location?"
                     placeholder="Please type the railroad company."
                     ngSpecialCharacter type="simple" [isLoading]="isLoadingScac" [isRequired]="true">
    </ns-autocomplete>
    <h4>What is your rail loading location?</h4>
    <div class="row">
      <div class="col col-lg-6">
        <ns-autocomplete (selected)="autocompleteSelected('originCity', 'originState')" [data]="states"
                         [formCtrl]="ecrForm.controls.originState" label="Origin State" ngSpecialCharacter type="grouped"
                         [isRequired]="true" [filter]="true" [filterByKeyAndValue]="true">
        </ns-autocomplete>
      </div>
      <div class="col col-lg-6">
        <ns-autocomplete [data]="destinationStations" [filter]=false [formCtrl]="ecrForm.controls.originCity" label="City"
                         ngSpecialCharacter type="simple" [isLoading]="isLoadingDS" [isRequired]="true">
        </ns-autocomplete>
      </div>
    </div>
    <h4>Please enter your STCC/Commodity Code or Description</h4>
    <ns-autocomplete [data]="stccDescription" [filter]=false [formCtrl]="ecrForm.controls.stccDescription" label="STCC/Description"
                     ngSpecialCharacter type="simple" [isLoading]="isLoadingStcc" [isRequired]="true">
    </ns-autocomplete>
  </form>
</ng-template>
